/**
 * @param nodeList {NodeList}
 * @returns {Array<Node>}
 */
export function nodeListToArray(nodeList) {
  if (!nodeList) {
    return []
  }

  const result = []

  for (let i = 0; i < nodeList.length; i++) {
    result.push(nodeList[i])
  }

  return result
}

/**
 * @param node {Node}
 * @param filter {Array<string>}
 * @return {Object}
 */
export function getPropsFromNode(node, filter = []) {
  if (!node) {
    return {}
  }

  const props = Array
    .from(node.attributes)
    .filter(attr => filter.indexOf(attr.name) === -1)
    .reduce((memo, attr) => ({
      ...memo,
      [attr.name]: attr.value,
    }), {})

  if (props.align) {
    props['class'] = `${props['class'] || ''} align${props.align}`.trim()
    props['data-align'] = props.align
    delete props.align
  }

  return props
}

export function nodeIs(node, ...elementNames) {
  if (!node?.nodeName) {
    return false
  }

  const nodeName = node.nodeName.toLowerCase()
  for (const candidate of elementNames) {
    if (nodeName === candidate) {
      return true
    }
  }

  return false
}

export function nodeMatches(node, selector) {
  return node?.matches?.(selector)
}
